export default "__VITE_ASSET__3277a96f__"